export default class DateHelper {
    static getRandomTime = () => Math.floor(Math.random() * 3000) + 1000;
}
